(() => {
  // --- Enhanced Script with Console Diagnostics ---

  const translations = {
    'de': { title: "Möchten Sie zur deutschen Seite wechseln?", yes: "Ja, wechseln", no: "Nein, danke" },
    'en': { title: "Would you like to switch to the English page?", yes: "Yes, switch", no: "No, thanks" },
    'es': { title: "Le gustaría cambiar a la página en español?", yes: "Sí, cambiar", no: "No, gracias" }
  };

  function initLanguageModal() {
    // Check if a modal already exists to prevent duplicates
    if (document.querySelector('.language-modal-overlay')) {
      return;
    }

    // Reason 1: User has already dismissed the modal in this session.
    if (sessionStorage.getItem('language-preference-dismissed')) {
      console.log('[LangSwitch] Modal dismissed by user in this session. Not showing.');
      return;
    }

    const browserLang = (navigator.language || navigator.userLanguage || 'en').substring(0, 2);
    const pageLang = document.documentElement.lang || 'de'; // Default to 'de' if lang attribute is missing

    // Reason 2: The browser language already matches the page language.
    if (browserLang === pageLang) {
      console.log(`[LangSwitch] Browser language ('${browserLang}') matches page language ('${pageLang}'). Not showing.`);
      return;
    }

    // Reason 3: We don't have a translation for the user's browser language.
    if (!translations[browserLang]) {
      console.log(`[LangSwitch] No translation available for browser language ('${browserLang}'). Not showing.`);
      return;
    }
    
    // If all checks pass, create the modal.
    console.log(`[LangSwitch] Conditions met. Creating modal for language '${browserLang}'.`);
    createModal(browserLang, pageLang);
  }

  function getRedirectUrl(browserLang) {
    const currentPath = window.location.pathname;
    const currentQuery = window.location.search;
    const currentOrigin = window.location.origin;
    
    let basePath = currentPath.replace(/^\/(en|es)/, '');
    if (basePath === '') basePath = '/';

    let newPath;
    if (browserLang === 'de') {
      newPath = basePath;
    } else {
      newPath = `/${browserLang}${basePath === '/' ? '' : basePath}`;
    }
    
    return `${currentOrigin}${newPath}${currentQuery}`;
  }

  function createModal(browserLang, pageLang) {
    const modalText = translations[browserLang];
    const modalOverlay = document.createElement('div');
    modalOverlay.className = 'language-modal-overlay';
    modalOverlay.innerHTML = `
      <div class="language-modal-content">
        <h2>${modalText.title}</h2>
        <div class="language-modal-buttons">
          <button class="language-modal-button yes">${modalText.yes}</button>
          <button class="language-modal-button no">${modalText.no}</button>
        </div>
      </div>
    `;

    document.body.appendChild(modalOverlay);

    setTimeout(() => modalOverlay.classList.add('visible'), 10);
    
    modalOverlay.querySelector('.yes').addEventListener('click', () => {
      window.location.href = getRedirectUrl(browserLang);
    });

    modalOverlay.querySelector('.no').addEventListener('click', () => {
      sessionStorage.setItem('language-preference-dismissed', 'true');
      modalOverlay.classList.remove('visible');
      setTimeout(() => modalOverlay.remove(), 300);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLanguageModal);
  } else {
    initLanguageModal();
  }
})();